export default __webpack_public_path__ + "static/media/cover (5).0b4f4e61.svg";